import { render } from "./LoginRegister.vue?vue&type=template&id=088e5d45&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"

import "./LoginRegister.vue?vue&type=style&index=0&id=088e5d45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088e5d45"]])

export default __exports__